<template>
  <div class="gestion">
    <b-container>
      <b-row>
        <b-col cols="7">
          <b-row>
            <b-col>
              <router-link to='asociacionismo'>
                <div class="button medium asociacionismo"></div>
              </router-link>
            </b-col>
            <b-col>
              <router-link to='gestion-administrativa'>
                <div class="button medium gestion-administrativa"></div>
              </router-link>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <router-link to='gestion-economica'>
                <div class="button medium gestion-economica"></div>
              </router-link>
            </b-col>
            <b-col>
              <router-link to='actividades'>
                <div class="button medium actividades"></div>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <div class="text">
            <h1>LIBRO DE GESTIÓN</h1>
            <p>
              Este material sirve como instrumento de orientación y ayuda a los Centros Juniors
              en la gestión de sus tareas. Está formado por cuatro manuales que son los pilares
              fundamentales para llevar a cabo los trámites que nos corresponden como
              asociación juvenil dedicada a la evangelización en el ocio y el tiempo libre. En él se
              han reunido temas de interés como son los referentes a las legislaciones vigentes
              en materia de asociacionismo y participación juvenil, los servicios ofrecidos por el
              Movimiento y algunas recomendaciones prácticas. Vuestra colaboración y respuesta
              medirá la utilidad de este libro pensado para coordinar los esfuerzos entre las
              Secretarías Diocesanas y cada Centro Juniors.
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row class="footer">
        <b-col cols="auto" class="ml-auto">
          <router-link to="/">
            <div class="button small back"></div>
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'gestion'
}
</script>

<style lang="scss" scoped>
@import '../styles/common.scss';
</style>
